export { saveConfig, getConfig, parseConstraintsForCheckGroups };

let CONFIG: AppMainConfig;

const saveConfig = (config: AppMainConfig) => {
    CONFIG = config;
};

const getConfig = () => Object.assign({}, CONFIG);

/**
 * Add to constraints all required checkbox with [group + id] key
 *
 * @param consents
 * @param constraints
 * @param group
 */
const parseConstraintsForCheckGroups = (consents: ConsentParent[], constraints: any, group: string) => {
    //
    if (constraints[group]) {
        consents
            .map((consent) => {
                if (consent.Required) {
                    constraints[`${group}${consent.Id}`] = constraints.Consents;
                }
                if (consent.Children) {
                    consent.Children
                        .filter((consent: any) => consent.Required)
                        .map((consentChild) => {
                            constraints[`${group}${consentChild.Id}`] = constraints.Consents;
                    });
                }
            });
        delete constraints[group];
    }

    return constraints;
};
